import { Link } from 'react-router-dom';
import { UpscalerApp } from '../components/UpscalerApp';
import { Seo } from '../components/Seo';
import { FaqBlock } from '../components/FaqBlock';
import { PAGES } from '../lib/config';
import { HOME_FEATURES, HOME_FAQ, TRUST_BAR, USE_CASES } from '../lib/content';
import { track } from '../lib/analytics';
import {
  softwareApplicationSchema,
  faqSchema,
  breadcrumbsSchema,
  websiteSchema,
  organizationSchema,
} from '../lib/schema';

const page = PAGES[0];

export function HomePage() {
  return (
    <>
      <Seo
        page={page}
        schemas={[
          websiteSchema(),
          organizationSchema(),
          softwareApplicationSchema(),
          faqSchema(HOME_FAQ),
          breadcrumbsSchema(page),
        ]}
      />
      <section className="bg-gradient-to-b from-primary-50/10 to-bg-base px-4 pb-16 pt-12 text-center sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <h1 className="text-4xl font-extrabold tracking-tight text-text-primary sm:text-5xl">
            {page.h1}
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-text-secondary">{page.subhead}</p>
          <div className="mt-8">
            <UpscalerApp uploadLabel={page.uploadLabel} />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl font-bold text-text-primary">How it works</h2>
        <div className="mt-8 grid gap-6 sm:grid-cols-3">
          {[
            { step: '1', title: 'Upload your image', text: 'Drag & drop or click to select.' },
            { step: '2', title: 'Choose 2× free. 4× Pro is planned.', text: 'Pick the upscale that fits your needs.' },
            { step: '3', title: 'Download in seconds', text: 'Get your enlarged image right away.' },
          ].map((item) => (
            <div key={item.step} className="rounded-xl border border-border-subtle bg-bg-elevated p-6 text-center shadow-sm">
              <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-primary-50 text-primary font-bold">
                {item.step}
              </div>
              <h3 className="font-semibold text-text-primary">{item.title}</h3>
              <p className="mt-2 text-sm text-text-secondary">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-bg-elevated px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <h2 className="text-center text-2xl font-bold text-text-primary">Why use Image Enlarger</h2>
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {HOME_FEATURES.map((f) => (
              <div key={f.title} className="rounded-xl border border-border-subtle bg-bg-elevated p-5">
                <h3 className="font-semibold text-text-primary">{f.title}</h3>
                <p className="mt-2 text-sm text-text-secondary">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl font-bold text-text-primary">Popular use cases</h2>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {USE_CASES.map((uc) => (
            <span key={uc} className="rounded-full bg-primary-50 px-4 py-2 text-sm font-medium text-primary">
              {uc}
            </span>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-sm text-text-secondary">
          {TRUST_BAR.map((t) => (
            <div key={t} className="flex items-center gap-2">
              <svg className="h-5 w-5 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              {t}
            </div>
          ))}
        </div>
      </section>

      <section className="bg-bg-elevated px-4 py-16 text-center text-text-primary sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold">Ready to enlarge your image?</h2>
        <Link
          to="/"
          onClick={() => track('cta_click', { location: 'home_bottom_hero', target: 'upload' })}
          className="mt-6 inline-block rounded-full bg-primary px-8 py-3 font-semibold text-white hover:bg-primary-hover"
        >
          Upload Image Free
        </Link>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8">
        <h2 className="text-center text-2xl font-bold text-text-primary">Frequently asked questions</h2>
        <div className="mt-8">
          <FaqBlock items={HOME_FAQ} />
        </div>
      </section>
    </>
  );
}
